import { McAction } from '../../IMcAction';
import initialState, { IOnBoardingState } from './IOnboardingState';
import { OnBoardingAnalyte } from '../../../contracts/onboarding/onboarding-analyte.model';
import { OnBoardingInstrument } from '../../../contracts/onboarding/onboarding-instrument.model';
import { OnBoardingInput, OnBoardingOutput } from '../../../contracts/onboarding/onboarding-input.model';
import { SelectedTeaConfig } from '../../../contracts/common/selected-tea-config.model';
import { USER_DEFINED_TEA } from '../../../contracts/common/const.model';
import { LevelData } from '../../../contracts/lab-test/level-data.model';
export function loadOnboardingSuccessful(state: IOnBoardingState, action: McAction): IOnBoardingState {

    const newState = Object.assign({}, state, {
        labId: action.payload.labId,
        instruments: action.payload.instruments,
        analytes: action.payload.analytes
    } as IOnBoardingState);
    return newState;
}

export function resetOnboarding(state: IOnBoardingState, action: McAction): IOnBoardingState {
    const newState = Object.assign({}, state, initialState);
    return newState;
}

export function updateHeaderInfo(state: IOnBoardingState, action: McAction): IOnBoardingState {
    return Object.assign({}, state, {
        headerInfo: action.payload
    } as IOnBoardingState);
}

export function updateSidePanelSelectedTab(state: IOnBoardingState, action: McAction): IOnBoardingState {
    return Object.assign({}, state, {
        sidePanelSelectedTab: action.payload
    } as IOnBoardingState);
}

export function selectInstrument(state: IOnBoardingState, action: McAction): IOnBoardingState {
    const currentSelectedItem = state.instruments.find(a => a.isSelected);
    const currentSelectedItemNewState = (currentSelectedItem) ? { ...currentSelectedItem, isSelected: false } : null;

    const selectedItem: OnBoardingInstrument = { ...action.payload, isSelected: true };
    if (currentSelectedItem && currentSelectedItem.instrument.labInstrumentId === selectedItem.instrument.labInstrumentId) {
        return state;
    }

    const newState: IOnBoardingState = {
        ...state,
        instruments: state.instruments.map(item => {
            if (currentSelectedItemNewState && item.instrument.labInstrumentId === currentSelectedItemNewState.instrument.labInstrumentId) {
                return Object.assign(new OnBoardingInstrument(), item, currentSelectedItemNewState);
            }

            if (item.instrument.labInstrumentId === selectedItem.instrument.labInstrumentId) {
                return Object.assign(new OnBoardingInstrument(), item, selectedItem);
            }
            return item;
        })
    };

    return newState;
}

export function selectAnalyte(state: IOnBoardingState, action: McAction): IOnBoardingState {
    const currentSelectedItem = state.analytes.find(a => a.isSelected);
    const currentSelectedItemNewState = (currentSelectedItem) ? { ...currentSelectedItem, isSelected: false } : null;

    const selectedItem: OnBoardingAnalyte = { ...action.payload, isSelected: true };

    const newState: IOnBoardingState = {
        ...state,
        analytes: state.analytes.map(item => {
            if (currentSelectedItemNewState && item.studyTestId === currentSelectedItemNewState.studyTestId) {
                return Object.assign(new OnBoardingAnalyte(), item, currentSelectedItemNewState);
            }

            if (item.studyTestId === selectedItem.studyTestId) {
                return Object.assign(new OnBoardingAnalyte(), item, selectedItem);
            }
            return item;
        })
    };


    return newState;
}

export function saveAnalytesStarts(state: IOnBoardingState, action: McAction): IOnBoardingState {
    return updateInstrumentIsProcessing(state, action, true);
}

export function saveAnalytesDone(state: IOnBoardingState, action: McAction): IOnBoardingState {
    return updateInstrumentIsProcessing(state, action, false);
}

function updateInstrumentIsProcessing(state: IOnBoardingState, action: McAction, isProcessing: boolean): IOnBoardingState {
    const instrumentIds: number[] = action.payload.instrumentIds;

    const newState: IOnBoardingState = {
        ...state,
        instruments: state.instruments.map(item => {
            if (instrumentIds.find(id => id === item.instrument.labInstrumentId)) {
                return {
                    ...item,
                    isProcessing
                };
            }

            return item;
        })
    };

    return newState;
}

export function saveAnalytesSuccessful(state: IOnBoardingState, action: McAction): IOnBoardingState {
    const savedAnalytesByStudyTestId = action.payload.analytesKeyByStudyTestId;

    const newState: IOnBoardingState = {
        ...state,
        analytes: state.analytes.map(item => {
            const savedAnalyte: OnBoardingAnalyte = savedAnalytesByStudyTestId[item.studyTestId];

            let updateItem;
            if (savedAnalyte) {
                updateItem = {
                    ...item,
                    studyTestDataId: savedAnalyte.studyTestDataId,
                    originalInputData: savedAnalyte.originalInputData,
                    inputData: savedAnalyte.inputData,
                    originalOutputData: savedAnalyte.originalOutputData,
                    outputData: savedAnalyte.outputData,

                } as OnBoardingAnalyte;
            } else {
                return item;
            }

            return Object.assign(new OnBoardingAnalyte(), item, updateItem);
        })
    };
    return newState;
}

export function checkedAnalyte(state: IOnBoardingState, action: McAction): IOnBoardingState {
    const analyteToCheck: OnBoardingAnalyte = action.payload.analyte || {} as OnBoardingAnalyte;
    const checked: boolean = action.payload.checked || false;

    const newState: IOnBoardingState = {
        ...state,
        analytes: state.analytes
            // For each analyte
            .map(item => {
                if (analyteToCheck.studyTestId && item.studyTestId !== analyteToCheck.studyTestId) {
                    return item;
                }
                // Update analyte
                const updatedItem = {
                    ...item,
                    isChecked: checked
                } as OnBoardingAnalyte;

                return Object.assign(new OnBoardingAnalyte(), item, updatedItem);
            })
    };


    return newState;
}

export function uncheckedAllAnalytes(state: IOnBoardingState, action: McAction): IOnBoardingState {
    const newState: IOnBoardingState = {
        ...state,
        analytes: state.analytes
            // For each analyte
            .map(item => {
                // Update analyte
                const updatedItem = {
                    ...item,
                    isChecked: false
                } as OnBoardingAnalyte;

                return Object.assign(new OnBoardingAnalyte(), item, updatedItem);
            })
    };


    return newState;
}

export function undoAnalyteChanges(state: IOnBoardingState, action: McAction): IOnBoardingState {
    const analyteToUndo: OnBoardingAnalyte = action.payload.analyte || {} as OnBoardingAnalyte;
    const newState: IOnBoardingState = {
        ...state,
        analytes: state.analytes
            // For each analyte
            .map(item => {
                if (analyteToUndo.studyTestId && item.studyTestId !== analyteToUndo.studyTestId) {
                    return item;
                }
                // Update analyte
                const updatedItem = {
                    ...item,
                    inputData: {
                        ...item.originalInputData
                    },
                    outputData: {
                        ...item.originalOutputData
                    }

                } as OnBoardingAnalyte;

                return Object.assign(new OnBoardingAnalyte(), item, updatedItem);
            })
    };

    return newState;
}


export function updateAnalytesWithInputData(state: IOnBoardingState, action: McAction): IOnBoardingState {
    let instrumentOrAnalyteData: OnBoardingInput = (action.payload.instrumentInputData
        || action.payload.analyteInputData) as OnBoardingInput;
    const payload = action.payload;
    const analyteTeaConfigSets = payload.analyteTeaConfigs || {};
    const skipNullValue = (payload.labInstrumentId) ? true : false;
    const copyInstrument = payload.copyInstrument;
    const copyLabInstrumentIds = (payload.copyInstrument) ? payload.copyLabInstrumentIds : null;
    const analyteOutputData = payload.analyteOutputData;
    const newState: IOnBoardingState = {
        ...state,
        analytes: state.analytes
            // For each analyte
            .map(item => {
                if (!copyInstrument) {
                    // Determine if updating all with instrument-wide data OR if updating just one analyte.
                    if ((payload.labInstrumentId && item.labInstrumentId !== payload.labInstrumentId)
                        || (payload.studyTestId && item.studyTestId !== action.payload.studyTestId)) {
                        return item;
                    }
                } else {
                    if ((payload.labInstrumentId) && (!copyLabInstrumentIds.includes(item.labInstrumentId))) {
                        return item;
                    }
                }

                // Clear Sigma from LevelData
                instrumentOrAnalyteData = clearSigmaFromLevelData(instrumentOrAnalyteData);

                // Update analyte
                const updatedItem = {
                    ...item,
                    inputData: updateAnalyteItem(item.inputData, instrumentOrAnalyteData, skipNullValue, copyInstrument),
                    outputData: (analyteOutputData) ? { ...analyteOutputData } : item.outputData

                } as OnBoardingAnalyte;

                // Ensure correct tea config is set
                const analyteTeaConfigs = analyteTeaConfigSets[item.studyTestId];
                let selectedTeaConfig = instrumentOrAnalyteData.input.selectedTeaConfig;

                // Make sure selected tea config is allowed for this analyte.
                // If not, just use original value.
                if (analyteTeaConfigs && selectedTeaConfig) {
                    // Find a tea config in the analytes compatible list of tea configs.
                    const teaConfig = analyteTeaConfigs.find((aConfig) => {
                        return aConfig.schema === selectedTeaConfig.teaConfig.schema;
                    });

                    // If tea config found matching given id, use it.
                    if (teaConfig) {
                        selectedTeaConfig = {
                            ...selectedTeaConfig,
                            studyTestId: item.studyTestId,
                            teaConfig: teaConfig
                        } as SelectedTeaConfig;
                    } else if (selectedTeaConfig.teaConfig.teaConfigId === USER_DEFINED_TEA) {
                        // User-defined value - update the studyTestId
                        selectedTeaConfig = Object.assign({}, selectedTeaConfig);
                        selectedTeaConfig.studyTestId = item.studyTestId;
                    } else {
                        // Invalid tea config for this analyte - keep original
                        selectedTeaConfig = item.originalInputData.input.selectedTeaConfig;
                    }

                    updatedItem.inputData.input.selectedTeaConfig =
                        getValue(item.originalInputData.input.selectedTeaConfig, selectedTeaConfig, skipNullValue);
                }

                return Object.assign(new OnBoardingAnalyte(), item, updatedItem);
            })
    };

    return newState;
}

function updateAnalyteItem(originalInput: OnBoardingInput, newInput: OnBoardingInput, skipNullValue: boolean, isCopyInstrument: boolean) {
    const result = {
        ...originalInput,
        allowableInput: {
            qcFrequency: getValue(originalInput.allowableInput.qcFrequency, newInput.allowableInput.qcFrequency, skipNullValue),
            qcRuleCode: getValue(originalInput.allowableInput.qcRuleCode, newInput.allowableInput.qcRuleCode, skipNullValue),
            qcRuleId: getValue(originalInput.allowableInput.qcRuleId, newInput.allowableInput.qcRuleId, skipNullValue)
        },
        input: {
            dateRange: getValue(originalInput.input.dateRange, newInput.input.dateRange, skipNullValue, isCopyInstrument),
            groupType: getValue(originalInput.input.groupType, newInput.input.groupType, skipNullValue, isCopyInstrument),
            harm: getValue(originalInput.input.harm, newInput.input.harm, skipNullValue),
            minimumPoints: getValue(originalInput.input.minimumPoints, newInput.input.minimumPoints, skipNullValue, isCopyInstrument),
            mtbf: getValue(originalInput.input.mtbf, newInput.input.mtbf, skipNullValue),
            numberOfPatients: getValue(originalInput.input.numberOfPatients, newInput.input.numberOfPatients, skipNullValue),

            severityOfHarmId: getValue(originalInput.input.severityOfHarmId, newInput.input.severityOfHarmId, skipNullValue),
            severityOfHarmValue: getValue(originalInput.input.severityOfHarmValue, newInput.input.severityOfHarmValue, skipNullValue),
            severityOfHarmName: getValue(originalInput.input.severityOfHarmName, newInput.input.severityOfHarmName, skipNullValue),

            selectedTeaConfig: getValue(originalInput.input.selectedTeaConfig, newInput.input.selectedTeaConfig, skipNullValue),
            teaGrammar: getValue(originalInput.input.teaGrammar, newInput.input.teaGrammar, skipNullValue),
            teaSchema: getValue(originalInput.input.teaSchema, newInput.input.teaSchema, skipNullValue),
            teaDesc: getValue(originalInput.input.teaDesc, newInput.input.teaDesc, skipNullValue)
        },
        levelData: getValue(originalInput.levelData, newInput.levelData, skipNullValue, isCopyInstrument)
    } as OnBoardingInput;

    return result;
}



function getValue(originalValue, newValue, skipNullValue, copyInstrument = false) {
    if (copyInstrument) {
        return originalValue;
    }
    if (newValue || !skipNullValue) {
        return newValue;
    } else {
        return originalValue;
    }
}

function clearSigmaFromLevelData(input: OnBoardingInput) {
    return {
        ...input,
        levelData: (input && input.levelData && input.levelData.length > 0) ? input.levelData.map((l) => clearSigma(l)) : input.levelData
    } as OnBoardingInput;
}

function clearSigma(levelData: LevelData) {
    return {
        ...levelData,
        sigma: null
    } as LevelData;
}





// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/app-states/modules/onboarding/onboarding.reducer.logic.ts